import React from "react";
import logo from "../../Assets/images/logo.svg";
// import bag from "../../Assets/icons/bag-c.svg";
import BagSvg from "./BagSvg";
import heart from "../../Assets/icons/heart.svg";
import { CovidContainer, CustomButton, Wrapper } from "./styles";
import { Link } from "react-router-dom";
const NavBar = () => {
  return (
    <Wrapper>
      <div className="container">
        <nav className="navbar bg-white px-0 navbar-expand-lg navbar-light bg-light">
          <Link className="navbar-brand mr-auto" to="/">
            <img alt="aorthar logo" src={logo} />
          </Link>
          <div className="w-100">
            <ul className="navbar-nav mr-auto" />
            <div className="row m-0 align-items-center justify-content-end ">
              <span className="navbar-text mr-3">
                <img src={heart} alt="aorthar-bag" />
              </span>
              <span>
                <BagSvg num="0" />
              </span>
              <CustomButton>Coming Soon</CustomButton>
            </div>
          </div>
        </nav>
      </div>

      <CovidContainer className="justify-content-center d-flex align-items-center">
        <p>
          COVID-19: Information about deliveries regulation.{" "}
          <span>View here</span>
        </p>
      </CovidContainer>
    </Wrapper>
  );
};

export default NavBar;
